import { configureStore, type AnyAction } from '@reduxjs/toolkit';
import { useDispatch, useSelector, type TypedUseSelectorHook } from 'react-redux';
import thunk, { type ThunkAction, type ThunkDispatch } from 'redux-thunk';
import { rootReducer, initialState } from './reducers';

export const store = configureStore({
  reducer: rootReducer,
  middleware: [thunk],
  preloadedState: initialState,
  devTools: process.env.NODE_ENV !== 'production',
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = ThunkDispatch<RootState, undefined, AnyAction>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, undefined, AnyAction>;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
